import { Card, CardContent, Stack, Typography, Chip, Link } from '@mui/material'
import { LabResultProps } from '../types'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useNavigation } from 'src/hooks'

export const NonNumericalLabResult = ({ labResult }: LabResultProps) => {
    const { navigate } = useNavigation()

    return (
        <Link
            component="div"
            onClick={() =>
                navigate(`/your-care/lab-results/history/${labResult.testCode}`)
            }
            sx={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'block',
                mt: 2
            }}
        >
            <Card
                elevation={0}
                sx={{
                    mt: 2,
                    border: 1,
                    borderColor: 'divider',
                    cursor: 'pointer'
                }}
            >
                <CardContent sx={{ px: 4 }}>
                    {/* Result Section */}
                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="start"
                        justifyContent="space-between"
                    >
                        <Stack>
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    variant="h6"
                                    sx={{ mb: 1, fontWeight: 'normal' }}
                                >
                                    {labResult.testName}
                                </Typography>
                                <ArrowForwardIcon color="action" />
                            </Stack>

                            {labResult.referenceRange?.text && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Normal range:{' '}
                                    {labResult.referenceRange.text}
                                </Typography>
                            )}

                            <Chip
                                label={
                                    labResult.valueString ||
                                    labResult.interpretation ||
                                    'N/A'
                                }
                                color="primary"
                                size="small"
                                sx={{
                                    mt: 1,
                                    width: 'fit-content',
                                    px: 1,
                                    py: 2
                                }}
                            />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Link>
    )
}
